import { createAction, delay } from '../utils';
import { CampaignAPIHelper } from '../services/CampaignAPIHelper';
import i18next from "i18next";


export const COUPON_CONFIRM_BUTTON_STATUS = {
  CONFIRM: 0,
  LOADING: 1,
  SUCCESS: 2,
  CALL_API_ERROR: 3,
  COUPON_REACH_LIMIT: 4,
  FAIL: 5
}

export const checkCouponIsUnavaiable = (data) => {
  if (data?.valid_period_type === "ABSOLUTE") {
    const absoluteEffectiveDate = new Date(data?.absolute_effective_date);
    const now = new Date();
    if (absoluteEffectiveDate > now) {
      return true;
    };
  };
  return false;
};

export default {
  namespace: 'buyCoupon',
  state: {
    confirmButtonStatus: COUPON_CONFIRM_BUTTON_STATUS.CONFIRM, // 0: confirm, 1: loading, 2: success, 3: false, 4: reach limit
    couponIsUnavaiable: false, // after buy coupon, click 'My Coupon' button redirect to tab 'Coming soon'
    errorMessage: ""
  },
  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
    resetCouponModal(state) {
      return {
        confirmButtonStatus: COUPON_CONFIRM_BUTTON_STATUS.CONFIRM,
        couponIsUnavaiable: false,
        errorMessage: ""
      };
    },
  },
  effects: {
    acquireRewardFailed: [
      function* ({ payload }, { call, put, select }) {
        const { response, isTicket } = payload;
        const errorDetail = response?.data?.detail || response?.data?.error;
        let errorMessage = i18next.t('campaignDetail:reachLimit');
        if (errorDetail === 'Desired coupons are sold out.') {
          errorMessage = i18next.t(isTicket ? 'campaignDetail:ticketOutOfStock' : 'campaignDetail:couponOutOfStock');
        } else if (errorDetail?.includes('Exceed campaign')) {
          errorMessage = i18next.t('campaignDetail:reachLimit');
        } else if (errorDetail?.includes('not available today')) {
          errorMessage = i18next.t('campaignDetail:blackoutLimit');
        } else if (errorDetail === 'Coupon expired.') {
          errorMessage = i18next.t('coupon:couponHasExpired');
        } else if (errorDetail === 'Ticket expired.') {
          errorMessage = i18next.t('coupon:ticketHasExpired');
        } else if (errorDetail === 'Customer is not eligible to this campaign.') {
          errorMessage = i18next.t('campaignDetail:notEligibleToTheCampaign');
        }
        // yield put({
        //   type: "navBars/updateState",
        //   payload: {
        //     toastShowing: {
        //       value: true,
        //       content: errorMessage,
        //     },
        //   },
        // });
        yield put(createAction('updateState')({
          confirmButtonStatus: COUPON_CONFIRM_BUTTON_STATUS.FAIL,
          errorMessage
        }));
      },
      { type: 'takeLatest' },
    ],
    buyCoupon: [
      function* ({ payload }, { call, put, select }) {
        const { campaignID, desiredStore, desiredUsageMedium, desiredQuantity } = payload;
        const startTime = Date.now();
        yield put(createAction('updateState')({
          confirmButtonStatus: COUPON_CONFIRM_BUTTON_STATUS.LOADING,
        }));
        const customerID = yield select((state) => state.users.userInfo.uid);
        try {
          const response = yield call(CampaignAPIHelper.participateCampaign, customerID, {
            campaign: campaignID,
            desired_coupon_quantity: desiredQuantity,
            desired_coupon_store: desiredStore,
            desired_coupon_usage_medium: desiredUsageMedium,
          });
          const endTime = Date.now();
          if (endTime - startTime < 1000) {
            yield call(delay, 1000 - endTime + startTime);
          }
          if (response.status < 300) {
            yield put(createAction('updateState')({
              confirmButtonStatus: COUPON_CONFIRM_BUTTON_STATUS.SUCCESS,
              couponIsUnavaiable: checkCouponIsUnavaiable(response?.data?.reward_coupon),
            }));
          } else {
            yield put({
              type: 'acquireRewardFailed',
              payload: {
                response,
              }
            })
          }
        } catch (error) {
          const endTime = Date.now();
          if (endTime - startTime < 1000) {
            yield call(delay, 1000 - endTime + startTime);
          }
          yield put(createAction('updateState')({
            confirmButtonStatus: COUPON_CONFIRM_BUTTON_STATUS.CALL_API_ERROR,
          }));
        }
      },
      { type: 'takeLatest' },
    ],
  },
};
